import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';

import GenericModal from '../../../Packages/SharedComponents/Com.Gyf.WebCore.GenericModal.jsx';
import MessagePopup from '../../../Packages/SharedComponents/Com.Gyf.WebCore.MessagePopup.jsx';

import Title from './Title.jsx';
import Header from './Header.jsx';
import DetalleConfiguracionPersonalizada from './DetalleConfiguracionPersonalizada.jsx';
import DetalleConfiguracionActiveDirectory from './DetalleConfiguracionActiveDirectory';

class ConfiguracionSesionVista extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.searchConfigurationSession(this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetStateConfigSesionVista();
    }

    render() {
        let component = null;
        let spinner = null;

        if (this.props.data.isFetching == true)
            spinner = <div className="loading">Loading&#8230;</div>

        if (this.props.data.isFetching == true)
            return spinner;

        //if (this.props.data.functions != undefined && this.props.data.functions.length > 0) {

            let functions = this.props.data.functions;

            //if (functions.Consulta == true) {
            //if (this.props.data.configuration == undefined)
            //        return spinner;

            if (this.props.data.tipoConfiguracion == 1) { 
                component = (
                    <div className="container-fluid concierge">
                        {spinner}

                        <div className="container-fluid concierge">
                            <Title titulo1={'Configuración de Sesiones'} titulo2={''} />
                            <Header functions={this.props.data.functions} />
                            <div>
                                <h3>La configuración de sesiones se administra de modo:</h3>
                            </div>
                            <DetalleConfiguracionPersonalizada alfabetica={this.props.data.alfabetica}
                                cantIntentosFallidos={this.props.data.cantIntentosFallidos}
                                cantidadRepeticiones={this.props.data.cantidadRepeticiones}
                                caracteresEspeciales={this.props.data.caracteresEspeciales}
                                caracteresMinimos={this.props.data.caracteresMinimos}
                                caseSensitive={this.props.data.caseSensitive}
                                maxDiasCaducidad={this.props.data.maxDiasCaducidad}
                                maxDiasInactividad={this.props.data.maxDiasInactividad}
                                minutosPermitidosInactividad={this.props.data.minutosPermitidosInactividad}
                                numerica={this.props.data.numerica}
                                permiteCaracteresIguales={this.props.data.permiteCaracteresIguales}
                                permiteLetrasConsecutivas={this.props.data.permiteLetrasConsecutivas}
                                permiteNrosConsecutivos={this.props.data.permiteNrosConsecutivos}
                                permiteRepetirPosicion={this.props.data.permiteRepetirPosicion}
                                plataformas = {this.props.data.plataformas}/>
                        </div>

                    </div>
                );
            } else {
                component = (
                    <div className="container-fluid concierge">
                        {spinner}

                        <div className="container-fluid concierge">
                            <Title titulo1={'Configuración de Sesiones'} titulo2={''} />
                            <Header functions={this.props.data.functions} />
                            <DetalleConfiguracionActiveDirectory
                                maxDiasInactividad={this.props.data.maxDiasInactividad}
                                minutosPermitidosInactividad={this.props.data.minutosPermitidosInactividad}
                                vincularGrupoWindows={this.props.data.vincularGrupoWindows}
                                altaAutomatica={this.props.data.altaAutomatica}
                                soloUsuarioLoggeado={this.props.data.soloUsuarioLoggeado}
                                solicitarContrasenia={this.props.data.solicitarContrasenia}/>
                        </div>

                    </div>
                );
            }
            //} else {
            //    let values = {
            //        message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
            //        linkMessage: "Volver a mi pagina de inicio"
            //    };

                //component = <GenericErrorScreen data={values} />;
            //}

            return (component);
        //} else {
        //    return null;
        //}
    }
}

export default ConfiguracionSesionVista;